import { ProductCatalogEmbroideryPlacement } from '../../../__generated__/graphql/catalog/graphql'
import { EmbroiderableProductFlatlayImage } from '../../../types/graphql/product'

import { getPlacementFromLegacyOffsetKey } from './getEmbroideryPlacement'

export function getFlatlayImageOffsetFromLegacyKey({
  flatlayImage,
  key,
}: {
  flatlayImage: EmbroiderableProductFlatlayImage | undefined | null
  key: string | undefined | null
}): EmbroiderableProductFlatlayImage['offsets'][number] | undefined {
  const placement = getPlacementFromLegacyOffsetKey(key)
  return getFlatlayImageOffset({
    flatlayImage,
    placement,
  })
}

export function getFlatlayImageOffset({
  flatlayImage,
  placement,
}: {
  flatlayImage: EmbroiderableProductFlatlayImage | undefined | null
  placement: ProductCatalogEmbroideryPlacement | undefined | null
}): EmbroiderableProductFlatlayImage['offsets'][number] | undefined {
  if (!placement) return undefined

  return flatlayImage?.offsets.find(offset => {
    if (offset.placement.location !== placement.location) return false
    if (offset.placement.position !== placement.position) return false
    return true
  })
}
